import { render, staticRenderFns } from "./FileLinkItem.vue?vue&type=template&id=38d6d889&scoped=true&"
import script from "./FileLinkItem.vue?vue&type=script&lang=js&"
export * from "./FileLinkItem.vue?vue&type=script&lang=js&"
import style0 from "./FileLinkItem.vue?vue&type=style&index=0&id=38d6d889&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d6d889",
  null
  
)

export default component.exports